module.exports = __webpack_public_path__ + "static/img/products_pu_mobile.0829dcf6.jpg";